/* TBC system layer: behaviour.

   1. Free shipping bar: Broadcast already recalculates the amount left when
      the cart changes. This only sets which of the three messages shows (far,
      near, met). Liquid sets the initial state in snippets/announcement.liquid.
   2. Footer accordions: opens the blocks flagged data-tbc-open on mobile once
      the theme's collapsible-elements has reset them.
   3. Product gallery: arrows on the thumbnail rail when it overflows. On the
      phone the rail sits under the swiped photo and follows the swipe. The
      theme keeps the active thumbnail in view on desktop itself. */

(function () {
  var BAR = '.announcement__wrapper .free-shipping[data-tbc-reach]';

  function currencyRate() {
    var shopify = window.Shopify;
    return (shopify && shopify.currency && Number(shopify.currency.rate)) || 1;
  }

  function cartUrl() {
    var shopify = window.Shopify;
    var root = (shopify && shopify.routes && shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function setReach(total) {
    document.querySelectorAll(BAR).forEach(function (bar) {
      var limit = Number(bar.getAttribute('data-free-shipping-limit')) * 100 * currencyRate();
      if (!limit) return;

      var gate = Number(bar.getAttribute('data-tbc-gate')) / 100;
      var left = limit - total;
      var reach = left <= 0 ? 'met' : left <= limit * gate ? 'near' : 'far';

      bar.setAttribute('data-tbc-reach', reach);
    });
  }

  function refresh() {
    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setReach(cart.total_price); })
      .catch(function () { /* keep the state Liquid rendered */ });
  }

  function watch() {
    var amounts = document.querySelectorAll(BAR + ' [data-left-to-spend]');
    if (!amounts.length || !('MutationObserver' in window)) return;

    var timer;
    var seen = new WeakMap();

    var observer = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        var node = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        var amount = node && node.closest('[data-left-to-spend]');
        if (!amount) return false;
        var text = amount.textContent;
        if (seen.get(amount) === text) return false;
        seen.set(amount, text);
        return true;
      });

      if (!changed) return;
      clearTimeout(timer);
      timer = setTimeout(refresh, 120);
    });

    amounts.forEach(function (amount) {
      seen.set(amount, amount.textContent);
      observer.observe(amount, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function openFlagged() {
    if (!MOBILE.matches) return;
    document.querySelectorAll('.site-footer collapsible-elements').forEach(function (host) {
      host.querySelectorAll('[data-collapsible][data-tbc-open]').forEach(function (item) {
        if (item.getAttribute('open') === 'true' || typeof host.open !== 'function') return;
        host.open(item);
      });
    });
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('collapsible-elements').then(function () {
        /* collapsible-elements resets open state in connectedCallback and on
           theme:resize:width; both listeners run before these. */
        requestAnimationFrame(openFlagged);
        document.addEventListener('theme:resize:width', function () {
          requestAnimationFrame(openFlagged);
        });
      });
    } else {
      openFlagged();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function () {
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6"/></svg>';

  function setupRail(rail) {
    var holder = rail.querySelector('[data-thumbs-slider]');
    if (!holder || rail.querySelector('.tbc-rail-arrow')) return;

    var labels = rail.closest('[data-tbc-gallery-labels]');
    var up = document.createElement('button');
    var down = document.createElement('button');
    up.type = down.type = 'button';
    up.className = 'tbc-rail-arrow tbc-rail-arrow--up';
    down.className = 'tbc-rail-arrow tbc-rail-arrow--down';
    up.innerHTML = ARROW;
    down.innerHTML = ARROW.replace('M6 15l6-6 6 6', 'M6 9l6 6 6-6');
    up.setAttribute('aria-label', (labels && labels.getAttribute('data-label-up')) || 'Previous images');
    down.setAttribute('aria-label', (labels && labels.getAttribute('data-label-down')) || 'More images');
    rail.appendChild(up);
    rail.appendChild(down);

    /* Arrows stay in place at the ends (dimmed), so keyboard focus is never dropped. */
    function update() {
      rail.classList.add('tbc-rail--overflow');
      var max = holder.scrollHeight - holder.clientHeight;
      if (max <= 1) rail.classList.remove('tbc-rail--overflow');
      max = holder.scrollHeight - holder.clientHeight;
      setDisabled(up, holder.scrollTop <= 1);
      setDisabled(down, max <= 1 || holder.scrollTop >= max - 1);
    }

    function setDisabled(button, off) {
      if (off) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    }

    function page(direction) {
      holder.scrollBy({ top: direction * (holder.clientHeight - 82), behavior: 'smooth' });
    }

    up.addEventListener('click', function () { if (up.getAttribute('aria-disabled') !== 'true') page(-1); });
    down.addEventListener('click', function () { if (down.getAttribute('aria-disabled') !== 'true') page(1); });
    holder.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    setTimeout(update, 600);
  }

  function setupCount(gallery) {
    var slides = gallery.querySelector('.product__slides');
    if (!slides || gallery.querySelector('.tbc-gallery-count')) return;
    var items = slides.querySelectorAll('.product__slide');
    var total = items.length;
    if (total < 2) return;

    /* The visual count is decorative; each slide states its own position. */
    var template = gallery.getAttribute('data-tbc-image-of') || 'Image __N__ of __TOTAL__';
    Array.prototype.forEach.call(items, function (item, index) {
      item.setAttribute('role', 'group');
      item.setAttribute('aria-roledescription', 'slide');
      item.setAttribute('aria-label', template.replace('__N__', index + 1).replace('__TOTAL__', total));
    });

    var count = document.createElement('p');
    count.className = 'tbc-gallery-count';
    count.setAttribute('aria-hidden', 'true');
    gallery.appendChild(count);

    function update() {
      var width = slides.clientWidth || 1;
      var index = Math.min(total, Math.round(slides.scrollLeft / width) + 1);
      count.textContent = index + ' / ' + total;
    }

    slides.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var PHONE = window.matchMedia('(max-width: 749px)');

  /* Phone: rail under the swiped photo. The swipe marks the thumbnail; a tap
     on a thumbnail scrolls the photo; arrows page the rail when it overflows. */
  function setupPhoneRail(gallery) {
    var slides = gallery.querySelector('.product__slides');
    var rail = gallery.querySelector('.product__thumbs');
    var holder = rail && rail.querySelector('[data-thumbs-slider]');
    if (!slides || !holder || rail.querySelector('.tbc-rail-arrow--prev')) return;
    var thumbs = holder.querySelectorAll('.product__thumb');
    if (thumbs.length < 2) { rail.hidden = true; return; }

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'tbc-rail-arrow--prev';
    next.className = 'tbc-rail-arrow--next';
    prev.innerHTML = ARROW.replace('M6 15l6-6 6 6', 'M15 6l-6 6 6 6');
    next.innerHTML = ARROW.replace('M6 15l6-6 6 6', 'M9 6l6 6-6 6');
    prev.setAttribute('aria-label', gallery.getAttribute('data-label-up') || 'Previous images');
    next.setAttribute('aria-label', gallery.getAttribute('data-label-down') || 'More images');
    rail.appendChild(prev);
    rail.appendChild(next);

    var current = -1;
    var target = -1;
    var STEP = 64;
    var template = gallery.getAttribute('data-tbc-image-of') || 'Image __N__ of __TOTAL__';

    function link(thumb) {
      return thumb.querySelector('[data-thumb-link]') || thumb.querySelector('a');
    }

    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      var a = link(thumb);
      if (a) a.setAttribute('aria-label', template.replace('__N__', i + 1).replace('__TOTAL__', thumbs.length));
    });

    function arrows() {
      if (!PHONE.matches) return;
      rail.classList.add('tbc-rail--overflow-x');
      var max = holder.scrollWidth - holder.clientWidth;
      if (max <= 1) rail.classList.remove('tbc-rail--overflow-x');
      max = holder.scrollWidth - holder.clientWidth;
      if (holder.scrollLeft <= 1) prev.setAttribute('aria-disabled', 'true'); else prev.removeAttribute('aria-disabled');
      if (max <= 1 || holder.scrollLeft >= max - 1) next.setAttribute('aria-disabled', 'true'); else next.removeAttribute('aria-disabled');
    }

    function mark(index) {
      if (index === current) return;
      current = index;
      Array.prototype.forEach.call(thumbs, function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        var a = link(thumb);
        if (a) a.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var thumb = thumbs[index];
      var left = thumb.offsetLeft;
      var right = left + thumb.offsetWidth;
      if (left < holder.scrollLeft) holder.scrollTo({ left: left, behavior: 'smooth' });
      else if (right > holder.scrollLeft + holder.clientWidth) holder.scrollTo({ left: right - holder.clientWidth, behavior: 'smooth' });
    }

    /* While a tapped thumbnail's photo scrolls in, the photos passed on the way are not marked. */
    function onSwipe() {
      if (!PHONE.matches) return;
      var width = slides.clientWidth || 1;
      var index = Math.max(0, Math.min(thumbs.length - 1, Math.round(slides.scrollLeft / width)));
      if (target !== -1) {
        if (index !== target) return;
        target = -1;
      }
      mark(index);
    }

    function page() {
      return Math.max(1, Math.floor((holder.clientWidth + 8) / STEP) - 1) * STEP;
    }

    slides.addEventListener('scroll', onSwipe, { passive: true });
    slides.addEventListener('touchstart', function () { target = -1; }, { passive: true });
    holder.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', function () { arrows(); onSwipe(); });

    /* Capture phase: the theme's own thumbnail handler drives the desktop fader. */
    holder.addEventListener('click', function (event) {
      if (!PHONE.matches) return;
      var thumb = event.target.closest('.product__thumb');
      if (!thumb) return;
      event.preventDefault();
      event.stopPropagation();
      var index = Array.prototype.indexOf.call(thumbs, thumb);
      target = index;
      slides.scrollTo({ left: index * slides.clientWidth, behavior: 'smooth' });
      mark(index);
    }, true);

    prev.addEventListener('click', function () {
      if (prev.getAttribute('aria-disabled') !== 'true') holder.scrollBy({ left: -page(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (next.getAttribute('aria-disabled') !== 'true') holder.scrollBy({ left: page(), behavior: 'smooth' });
    });

    /* Rotation crosses the breakpoint: hand the current photo to the desktop
       gallery, and pick up the desktop's photo when coming back. */
    function mediaId(index) {
      var a = thumbs[index] && link(thumbs[index]);
      return a && a.getAttribute('data-media-id');
    }

    PHONE.addEventListener('change', function () {
      if (!PHONE.matches) {
        var id = mediaId(current);
        if (id) gallery.dispatchEvent(new CustomEvent('theme:media:select', { bubbles: true, detail: { id: id } }));
        return;
      }
      var active = gallery.getAttribute('data-active-media');
      var index = 0;
      Array.prototype.forEach.call(thumbs, function (thumb, i) { if (mediaId(i) === active) index = i; });
      slides.scrollLeft = index * slides.clientWidth;
      current = -1;
      mark(index);
      arrows();
    });

    onSwipe();
    arrows();
    setTimeout(arrows, 600);
  }

  function start() {
    document.querySelectorAll('.index-product .product__wrapper--thumbnails-left .product__thumbs').forEach(setupRail);
    document.querySelectorAll('.index-product .product__images--mobile-slider').forEach(function (gallery) {
      setupCount(gallery);
      setupPhoneRail(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/* Cart prices against the wholesale app (BSS B2B): a moment after the cart
   is drawn it rewrites every line's price as plain text, for every shopper,
   which drops the sale price's red and the struck full price. When the price
   it writes is the line's own (data-tbc-final, in cents), the line gets the
   theme's markup back; a different price is a wholesale one and stays. */
(function () {
  var drawn = new WeakMap();

  function cents(text) {
    var match = String(text || '').replace(/[^\d.,]/g, '').match(/^(\d+(?:[.,]\d{3})*)(?:[.,](\d{2}))?$/);
    if (!match) return null;
    return Number(match[1].replace(/[.,]/g, '')) * 100 + Number(match[2] || 0);
  }

  function keep(node) {
    if (!drawn.has(node)) drawn.set(node, node.innerHTML);
  }

  function check(node) {
    var original = drawn.get(node);
    if (original === undefined || node.innerHTML === original) return;
    var written = node.querySelector('del') ? null : cents(node.textContent);
    if (written !== null && String(written) === node.getAttribute('data-tbc-final')) node.innerHTML = original;
  }

  function scan(root) {
    if (root.matches && root.matches('.cart__price[data-tbc-final]')) keep(root);
    if (root.querySelectorAll) root.querySelectorAll('.cart__price[data-tbc-final]').forEach(keep);
  }

  function start() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        var price = target && target.closest && target.closest('.cart__price[data-tbc-final]');
        if (price) check(price);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
